export default "__VITE_ASSET__qh1DtJqq__"